import { render, staticRenderFns } from "./right.vue?vue&type=template&id=71a5f528&scoped=true"
import script from "./right.vue?vue&type=script&lang=js"
export * from "./right.vue?vue&type=script&lang=js"
import style0 from "./right.vue?vue&type=style&index=0&id=71a5f528&prod&scoped=true&lang=css"
import style1 from "./right.vue?vue&type=style&index=1&id=71a5f528&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a5f528",
  null
  
)

export default component.exports